import React, { Component } from 'react';
import dayjs from 'dayjs';
import i18n from '../../../i18n';
import { connect } from 'react-redux'
class coupondetail extends Component {
  renderCheckBox = (isSelected, isUsable) => {
    if (isUsable) {
      return (
        <div
          style={{ display: 'flex', flex: 1, justifyContent: 'center' }}
          onClick={this.props.onCouponSelected}
        >
          <div
            className="regesitered-coupon-list"
            style={{ padding: 0, width: 'unset' }}
          >
            <input
              id={this.props.box}
              className="css-checkbox coupon-checkbox"
              checked={isSelected}
              type="checkbox"
            />
            <label
              style={{ paddingLeft: '20px', width: 'unset', height: '19.5px' }}
              htmlFor={this.props.box}
              className="css-label"
              name="UG"
            />
          </div>
        </div>
      )
    }
    return (
      <div
        style={{ display: 'flex', flex: 1, justifyContent: 'center', visibility: 'hidden' }}
      >
      </div>
    )
  }

  IsCouponUseable = () => {
    const {
      coupon,
      productId
    } = this.props

    if (!coupon || !coupon.data) return false

    const { action } = coupon.data
    switch (action) {
      case 'AddPeriod':
      case 'DiscountAll':
      case 'DiscountPercentage':
      case 'DiscountAmount':
        {
          const { productId: productIdArr } = coupon.data
          if (!productId || !Array.isArray(productIdArr)) return false

          for (let i = 0; i < productIdArr.length; i++) {
            if (productIdArr[i] === productId) return true
          }
          return false
        }

      default:
        return false
    }
  }

  render() {
    const {
      coupon,
      isSelected,
      value,
      showCheckbox
    } = this.props;

    let isUseable = this.IsCouponUseable()
    return (
      <div style={{ display: 'flex', padding: '15px 0', alignItems: 'center' }}>
        <div style={{ display: 'flex', flex: 2.4, justifyContent: 'center', fontSize: "13px", flexDirection: 'column' }}>
          <div>{coupon.name[value]}</div>
          <div style={{ marginTop: 5, fontSize: '11px', fontWeight: 500, color: '#1fbdcb' }}>{coupon.description[value]}</div>
        </div>
        <div style={{ display: 'flex', flex: 1, justifyContent: 'center', fontSize: "13px", padding: "0 15px" }}>
          {`~${dayjs(coupon.expiredAt).utc().format("YY.MM.DD")}`}
        </div>

        <div style={{ display: 'flex', flex: 1, justifyContent: 'center', fontSize: "13px" }}>
          {`${coupon.restCount}${i18n.t("coupon.remain.count")}`}
        </div>
        {
          showCheckbox &&
          (
            isUseable ? this.renderCheckBox(isSelected, isUseable) : <div style={{ display: 'flex', flex: 1, justifyContent: 'center', color: 'red' }}>{i18n.t("coupondetail.not.isUsable")}</div>
          )
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  value: state.langStore.lang
})

export default connect(mapStateToProps, null)(coupondetail)
